module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-company/01-c867651a08dcc05390a9cb88adf86d28.png";